export const formatMoney = (amount) => {
    if (typeof amount !== 'number') return '--';
    return amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-GB');
};